var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "dropdown-menu announcement-menu" },
    [
      _vm._l(_vm.announcements, function (a) {
        return _c(
          "li",
          {
            key: a._id,
            staticClass: "title",
            class: { read: a.read },
            on: {
              click: function ($event) {
                return _vm.read(a._id)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.naming(a)) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _vm.moreAnnouncements
        ? [
            _c("li", { staticClass: "split" }),
            _vm._v(" "),
            _c("li", { staticClass: "more", on: { click: _vm.more } }, [
              _vm._v("\n      view more\n    "),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }